import script from "./FooterComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterComponents.vue?vue&type=script&setup=true&lang=js"

import "./FooterComponents.vue?vue&type=style&index=0&id=1c3e464c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3e464c"]])

export default __exports__